export enum InteractionObjectType {
  PROJECT = "Project",
  ORGANISATION = "Organisation",
  ISSUANCE = "Issuance",
  ISSUANCE_TRANSACTION = "Issuance Transaction",
  DEAL = "Deal",
  LANDHOLDING = "Landholding",
  WORKFLOW_TASK = "WorkflowTask",
}

export enum ObjectInteractionObjectType {
  PROJECT = "Project",
  ORGANISATION = "Organisation",
}

export enum InteractionType {
  TAG = "Tag",
  NOTE = "Note",
}

/*
  object_type values for an object_document link. A different contract from InteractionObjectType above,
  which the tag and note endpoints use: those spell the same concept "Issuance Transaction", while
  object_document spells it "IssuanceTransaction". The server resolves an object_document type
  case-insensitively but not space-insensitively, so a value carrying the space matches no policy and is
  rejected as VALIDATION_OBJECT_TYPE_INVALID. The two enums cannot share a value.
*/
export enum ObjectDocumentObjectType {
  WORKFLOW_TASK = "WorkflowTask",
  ISSUANCE_TRANSACTION = "IssuanceTransaction",
}

/*
  document_source values for an object_document link. The server only accepts a source that matches the
  parent of the object being linked to — a Project parent takes ProjectDocument and a Deal parent takes
  DealDocument; any other pairing is rejected as VALIDATION_DOCUMENT_PARENT_MISMATCH.
*/
export enum ObjectDocumentSource {
  PROJECT_DOCUMENT = "ProjectDocument",
  DEAL_DOCUMENT = "DealDocument",
}
